import { render, staticRenderFns } from "./BaseHugeCalendarUi.vue?vue&type=template&id=038d8a37&scoped=true"
import script from "./BaseHugeCalendarUi.vue?vue&type=script&lang=js"
export * from "./BaseHugeCalendarUi.vue?vue&type=script&lang=js"
import style0 from "./BaseHugeCalendarUi.vue?vue&type=style&index=0&id=038d8a37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d8a37",
  null
  
)

export default component.exports